import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import DataTable from "react-data-table-component";
import { ComponentToPrint } from './ComponentToPrint';
import ReactToPrint from 'react-to-print';

interface IFormProps {
  setForEdit: any,
  addNew: any,
}
interface MyStates {
  ajaxLoaded: number,
  orders: any,
  defaultSortField: string,
  defaultSortAsc: boolean,
  search: string,
  sorting: object,
  totalRows: number,
  displayRows: number,
  currentPage: number,
  spinner: string
}
export default class ServicesDatatable extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: 0,
      orders: [], 
      sorting: {}, 
      totalRows: 0, 
      displayRows: 10, 
      currentPage: 1,
      defaultSortField: 'code', 
      defaultSortAsc: true, 
      search: '',
      spinner: 'flex'
    }
    this.loadOrders()
  }

  private loadOrders(filters = {}) {
    var ajax = new Ajax(window.location.origin + '/reservatio/foglalasok/getOrders');
    ajax.doPost({
      filters: filters, 
      limit: this.state.displayRows,
      offset: this.state.currentPage,
      sorting: this.state.sorting,
      search: this.state.search,
      type: 'onlytrashed'
    }).then((response) => {
      this.setState({
        ajaxLoaded: Math.random(),
        orders: response.orders,
        totalRows: response.total_rows,
        spinner: 'none'
      })
    })
  }
  private unRemoveThis(id){
    swal({
        title: "Biztos, hogy visszavonja ezt a törlést?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {
          this.setState({
            spinner: 'flex'
          }, () => {
            var ajax = new Ajax(window.location.origin + '/reservatio/foglalasok/undelete/'+id);
              ajax.doPost({}).then((response) => {
              this.loadOrders()
            })
          })
        }
    });
  }

  private handlePerRowsChange(e){
    this.setState({
      displayRows: e,
      spinner: 'flex'
    }, () => this.loadOrders())
  }

  private handlePageChange(e){
    this.setState({
      currentPage: e,
      spinner: 'flex'
    }, () => this.loadOrders())
  }

  private search(e){
    this.setState({
      search: e.target.value,
      spinner: 'flex'
    }, () => this.loadOrders())
  }
  private refresh(){
    this.setState({
      spinner: 'flex'
    }, () => this.loadOrders())
  }

  private doSort(e, ordering){
    this.setState({
      sorting: {
        'column': e.selector,
        'ordering': ordering
      }, 
      defaultSortField: e.selector, 
      defaultSortAsc: ordering == 'asc' ? true : false,
      spinner: 'flex'
    }, () => this.loadOrders())
  }


  public render() {
    const columns = [
      {
        width: '150px',
        name: 'Beérkezett',
        selector: 'created_at',
        sortable: true,
        cell: row => row.created_at,
      },
      {
        width: '150px',
        name: 'Törölve',
        selector: 'deleted_at',
        sortable: true,
        cell: row => row.deleted_at,
      },
      {
        width: '100px',
        name: 'Azonosító',
        selector: 'formatted_id',
        sortable: true,
        cell: row => row.formatted_id,
      },
      {
        name: 'Kapcsolattartó',
        selector: 'contact_name',
        sortable: true,
        cell: row => row.contact_name,
      },
      {
        name: 'Telefonszám',
        selector: 'phone',
        sortable: true,
        cell: row => row.phone,
      },
      {
        name: 'E-mail cím',
        selector: 'email',
        sortable: true,
        cell: row => row.email,
      },
      {
        name: 'Csoport',
        selector: 'group_name',
        sortable: true,
        cell: row => row.group_name,
      },
      {
        name: 'Megrendelés típusa',
        selector: 'type',
        sortable: true,
        cell: row => row.type,
      },
      {
        name: 'Érkezés',
        selector: 'first_date',
        sortable: true,
        cell: row => row.first_date,
      },
      {
        name: 'Távozás',
        selector: 'departure_date',
        sortable: true,
        cell: row => row.departure_date,
      },
      {
        name: 'Teljes ár',
        selector: 'full_price',
        sortable: true,
        cell: row => this.getPriceFormat(row.full_price),
      },
      {
        name: 'Fizetési mód',
        selector: 'payment_method',
        sortable: true,
        cell: row => row.payment_method,
      },
      {
        name: 'Státusz',
        selector: 'approval',
        sortable: true,
        cell: row => row.approval,
      },
      {
        width: '160px',
        name: '',
        selector: 'menu',
        sortable: false,
        cell: row => {
          return (
          <>
            <button type="button" className="btn btn-success btn-sm" style={{marginRight: '10px'}} onClick={() => this.props.setForEdit(row.id)}><i className="fa fa-pencil"></i></button>
            <button type="button" className="btn btn-danger btn-sm" onClick={() => this.unRemoveThis(row.id)}>Visszavonás</button>
          </>)
        },
      },
    ]

    const data = this.state.orders
    
    return (
    <>
     
      <div className="row">
       
      </div>
      <div className="box">
        <div className="box-header">
          <h3 className="box-title">Törölt rendelések</h3>
          <button type="button" className="btn btn-success btn-sm" onClick={() => this.refresh()}><i className="fa fa-refresh"></i></button>
          <input type="text" className="form-control" placeholder="Keresés..." onChange={(e) => this.search(e)} /> 
        </div>
        <div className="box-body table-responsive" style={{position: 'relative'}}>
          <div className="spinner-fill" style={{display: this.state.spinner}}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          <DataTable 
            noHeader 
            pagination
            paginationServer
            keyField='efactory_item_id'
            defaultSortField={this.state.defaultSortField}
            defaultSortAsc={this.state.defaultSortAsc}
            paginationTotalRows={this.state.totalRows}
            paginationDefaultPage={this.state.currentPage}
            onChangeRowsPerPage={(e) => this.handlePerRowsChange(e)}
            onChangePage={(e) => this.handlePageChange(e)}
            columns={columns} 
            data={data} 
            onSort={(e,x) => this.doSort(e,x)} />
        </div>
      </div>
    </>
    )
  }
  
  private getPriceFormat(price, text = ''){
    if( price == 0 ){
      return <div className="price">Díjtalan</div>
    } else {
      return <div className="price">{price > 0 ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")+' Ft' : '-'}  {text}</div>
    }
  }
}